export default __webpack_public_path__ + "static/media/breakfast.26447ef1.svg";